<template lang="pug">
login-wrapper(childClass="box-forgot")
  slot
        legend Изменение пароля
        .form-group(:class="{'has-error': !passwordValid}")
            .vfl-field.input-group(style='width: 100%;')
                input(type="password", 
                      required="",
                      v-model="password",
                      @blur="passwordChanged = true",
                      @focus="passwordChanged = false")
                span.field-underline
                label Пароль
                    span(v-if="passwordChanged && tooShortPassword") <b> – минимум 6 символов </b>
        .form-group(:class="{'has-error': passwordCheckChanged && passwordsNotEqual}")
            .vfl-field.input-group(style='width: 100%;')
                input(type="password", 
                      required="",
                      v-model="passwordCheck",
                      @blur="passwordCheckChanged = true")
                span.field-underline
                label Ещё разок пароль
                    span(v-if='passwordCheckChanged && passwordsNotEqual') <b> – пароли не совпадают</b>
        p(v-if="errorMessage") {{ errorMessage }}
        .form-actions
          router-link(:to="{name: 'Login'}").btn.btn-default
            | Вернуться ко входу
          button.btn.btn-primary.pull-right(@click.prevent="login")
            | Готово

</template>

<script>
import LoginWrapper from '@/components/auth/LoginWrapper';

export default {
    name: 'PasswordChange',
    components: {
        LoginWrapper
    },
    methods: {
        login() {
            if (this.validate()) {
                this.$store.dispatch('changePassword', {
                    token: this.$route.params.token,
                    password: this.password
                }).catch((errorMessage) => {
                    this.errorMessage = errorMessage;
                });
            }
        },
        validate() {
            this.passwordChanged = this.passwordCheckChanged = true;
            return this.passwordValid;
        }
    },
    computed: {
        passwordsNotEqual() {
            return this.password !== this.passwordCheck;
        },
        tooShortPassword() {
            return !this.password || this.password.length < 6;
        },
        passwordValid() {
            return !(
                (this.passwordChanged && this.tooShortPassword) ||
                (this.passwordChanged && this.passwordCheckChanged && this.passwordsNotEqual)
            );
        }
    },
    data() {
        return {
            password: null,
            passwordCheck: null,

            passwordChanged: false,
            passwordCheckChanged: false,

            errorMessage: null
        };
    }
};
</script>


// WEBPACK FOOTER //
// src/components/auth/PasswordChange.vue